import { useContext, useEffect, useState } from "react";
import app from "nystem";
import { ContentTypeView, DatabaseSearchContext, Wrapper } from "nystem-components";

const ViewListCollage = ({ model, view }) => {
  const { search } = useContext(DatabaseSearchContext);
  const [collageView, setCollageView] = useState();
  const images = (search?.data || []).filter((image) => image.file);
  const [error, setError] = useState(false);
  const [prints] = useState(() => [
    { left: -9, top: -12, width: 49, height: 65, rotate: -13 },
    { left: 27, top: -15, width: 48, height: 62, rotate: 8 },
    { left: 66, top: -8, width: 48, height: 66, rotate: -9 },
    { left: -12, top: 48, width: 49, height: 65, rotate: 7 },
    { left: 26, top: 50, width: 48, height: 63, rotate: -11 },
    { left: 66, top: 44, width: 49, height: 68, rotate: 12 },
    { left: 13, top: 7, width: 31, height: 49, rotate: 11 },
    { left: 53, top: 2, width: 32, height: 43, rotate: -16 },
    { left: -3, top: 31, width: 32, height: 45, rotate: -8 },
    { left: 33, top: 28, width: 35, height: 52, rotate: 5 },
    { left: 76, top: 32, width: 31, height: 47, rotate: -12 },
    { left: 51, top: 66, width: 32, height: 47, rotate: 14 },
  ].map((print) => ({
    ...print,
    left: print.left + Math.random() * 16 - 8,
    top: print.top + Math.random() * 16 - 8,
    width: print.width + Math.random() * 10,
    height: print.height + Math.random() * 10,
    rotate: Math.random() * 36 - 18,
  })));
  useEffect(() => {
    if (model.results) return;
    let mounted = true;
    const load = async () => {
      const filter = [];
      if (model.favorites) {
        const result = await app.database.tag.search({ filter: { name: "Favorite" }, exact: true, count: 1 });
        if (result.error) throw new Error(result.error);
        if (!result.data?.length) return;
        filter.push({ and: [["tag", result.data[0]._id]] });
      }
      if (mounted) setCollageView({ format: "view", item: [
        ...model.item.map((item) => item.type === "database" && item.format === "search" ? { ...item, filter: [...(item.filter || []), ...filter] } : item),
        { ...model, results: true, item: undefined },
      ] });
    };
    load().catch(() => { if (mounted) setError(true); });
    return () => { mounted = false; };
  }, [model]);
  if (!model.results && collageView) return <ContentTypeView contentType="image" view={collageView} baseView={view} noForm />;
  return <Wrapper className={model.className}>
    {model.results && images.length ? <div className={model.scattered ? "relative h-full w-full overflow-hidden bg-[#d4d9ce]" : `grid h-full w-full gap-1 ${images.length > 1 ? "grid-cols-2" : "grid-cols-1"}`}>
      {images.map((image, index) => <div key={image._id} className={model.scattered ? `absolute overflow-hidden bg-white shadow-[0_6px_14px_rgba(0,0,0,0.45),0_2px_5px_rgba(0,0,0,0.35)] ${model.shadowOnly ? "" : "border-4 border-white"}` : `relative min-h-0 overflow-hidden ${images.length === 3 && index === 0 ? "row-span-2" : ""}`} style={model.scattered ? {
        width: `${prints[index % prints.length].width}%`,
        height: `${prints[index % prints.length].height}%`,
        left: `${prints[index % prints.length].left}%`,
        top: `${prints[index % prints.length].top}%`,
        transform: `rotate(${prints[index % prints.length].rotate}deg)`,
      } : undefined}>
        <img src={`/${image.file.type}/800x800/${image.file.id}.${image.file.ext}`} alt={image.alt || image.title || "Trip photograph"} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
      </div>)}
    </div> : <div className="flex h-full items-center justify-center bg-[#e5ebe2] px-6 text-center text-sm text-[#59665e]">{error ? "Photos could not be loaded." : model.favorites ? "Mark photos as Favorite to see them here." : "No photos in this trip yet."}</div>}
  </Wrapper>;
};

export default ViewListCollage;
